import * as React from 'react';
import classify from 'src/utils/classify';
import {
  BodyMedium,
  FormLabelSmall,
  Truncate,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referral-v2/table/table.css';


const ReferralDetailRow = ({
  label,
  value,
  customComponent,
  autoTruncate = false,
  className,
}: {
  label: string;
  value?: string | null | undefined | number;
  customComponent?: React.ReactNode | null | undefined;
  autoTruncate?: boolean;
  className?: string;
}) => {
  return (
    <div className={classify(css.cardRow, className)}>
      <FormLabelSmall>{label}</FormLabelSmall>
      {!customComponent && (
        <BodyMedium color={'secondary'}>
          {!value ? (
            '-'
          ) : autoTruncate ? (
            <Truncate
              className={css.truncate}
              line={1}
              showFullTextOnHover={true}
            >
              {value}
            </Truncate>
          ) : (
            value
          )}
        </BodyMedium>
      )}
      {customComponent}
    </div>
  );
};

export default ReferralDetailRow;
